module.exports = __webpack_public_path__ + "static/nodejs-b4f7315308699964666c69062752d065.svg";